(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2617],{

/***/ 73252:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/billing",
      function () {
        return __webpack_require__(91007);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ WhitePanel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47842);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2902);





function WhitePanel(param) {
    var children = param.children, className = param.className, _ignorePadding = param.ignorePadding, ignorePadding = _ignorePadding === void 0 ? false : _ignorePadding, _ignoreVertical = param.ignoreVertical, ignoreVertical = _ignoreVertical === void 0 ? false : _ignoreVertical, _borderSizing = param.borderSizing, borderSizing = _borderSizing === void 0 ? "rounded-[12px]" : _borderSizing;
    var isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var _obj;
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()("bg-white border-gray-200 border mb-3 text-passport ".concat(isMobile ? "min-w-[280px]" : "", " "), borderSizing, className, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "px-3 sm:px-4 md:px-10", !ignorePadding), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "py-8", !ignoreVertical), _obj));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classNames,
        children: children
    });
}
function PanelTitle(param) {
    var children = param.children, className = param.className, _defaultMargin = param.defaultMargin, defaultMargin = _defaultMargin === void 0 ? "mb-2" : _defaultMargin, _textClassName = param.textClassName, textClassName = _textClassName === void 0 ? "text-lg text-passport" : _textClassName;
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()(defaultMargin, className);
    var textClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()(textClassName);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classNames,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
            className: textClass,
            children: children
        })
    });
}
function PanelSubtitle(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "text-sm" : _className;
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, className, className));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "mb-6 text-sm text-passport",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: classNames,
            children: children
        })
    });
}
function PanelContent(param) {
    var children = param.children, className = param.className;
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-full flex flex-grow text-passport", className);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classNames,
        children: children
    });
}
function PanelHeadDivider(param) {
    var children = param.children, className = param.className;
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()("flex justify-between pb-5 border-b border-gray-200 text-passport", className);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classNames,
        children: children
    });
}
WhitePanel.Title = PanelTitle;
WhitePanel.Subtitle = PanelSubtitle;
WhitePanel.Content = PanelContent;
WhitePanel.HeadDivider = PanelHeadDivider;


/***/ }),

/***/ 3023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ LeftsideNav; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _components_common_navigation_ActiveNavLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45364);
/* harmony import */ var _hooks_user_useUserPermissions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38734);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55123);
/* harmony import */ var _skipper_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23357);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);







var ManagedLinks = [
    {
        name: "Profile",
        route: "/users/edit",
        permissionCheck: _hooks_user_useUserPermissions__WEBPACK_IMPORTED_MODULE_3__/* .Permissions.manage_profile */ .Pl.manage_profile
    },
    {
        name: "Manage Family",
        route: "/account/seats",
        roleCheck: _hooks_user_useUserPermissions__WEBPACK_IMPORTED_MODULE_3__/* .Roles.Adult */ .G7.Adult
    },
    {
        name: "My Enrollments",
        route: "/account/enrollments"
    },
    {
        name: "Manage Courses",
        route: "/account/manage-active",
        roleCheck: _hooks_user_useUserPermissions__WEBPACK_IMPORTED_MODULE_3__/* .Roles.Adult */ .G7.Adult
    },
    {
        name: "Manage Members",
        route: "/account/manage-members",
        roleCheck: _hooks_user_useUserPermissions__WEBPACK_IMPORTED_MODULE_3__/* .Roles.Adult */ .G7.Adult
    },
    {
        name: "Notifications",
        route: "/users/notifications",
        permissionCheck: _hooks_user_useUserPermissions__WEBPACK_IMPORTED_MODULE_3__/* .Permissions.notification_settings */ .Pl.notification_settings
    },
    {
        name: "Account Settings",
        route: "/account/settings",
        roleCheck: _hooks_user_useUserPermissions__WEBPACK_IMPORTED_MODULE_3__/* .Roles.Adult */ .G7.Adult
    },
    {
        name: "Billing and Plans",
        route: "/account/billing",
        roleCheck: _hooks_user_useUserPermissions__WEBPACK_IMPORTED_MODULE_3__/* .Roles.Adult */ .G7.Adult
    },
    {
        name: "Permission Levels",
        route: "/account/permission-levels",
        roleCheck: _hooks_user_useUserPermissions__WEBPACK_IMPORTED_MODULE_3__/* .Roles.Adult */ .G7.Adult
    }, 
];
function LeftsideNav(param) {
    var children = param.children, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "bg-white" : _bgColor, subHeaderContent = param.subHeaderContent, breadCrumb = param.breadCrumb, breadCrumbUrl = param.breadCrumbUrl, breadCrumSub = param.breadCrumSub, breadCrumSubUrl = param.breadCrumSubUrl;
    var ref = (0,_hooks_user_useUserPermissions__WEBPACK_IMPORTED_MODULE_3__/* .useUserPermissions */ .Qe)(), hasPermission = ref.hasPermission, hasRole = ref.hasRole;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "h-full w-full",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative h-full w-full ".concat(bgColor, " pr-14"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.div */ .E.div, {
                    initial: false,
                    animate: {
                        width: "".concat(240, "px"),
                        minWidth: "".concat(240, "px")
                    },
                    className: "border-r border-gray-300 whitespace-nowrap h-full block overflow-auto bg-white px-2",
                    children: ManagedLinks.filter(function(r) {
                        if (!!r.permissionCheck) {
                            return hasPermission(r.permissionCheck);
                        }
                        if (!!r.roleCheck) {
                            return hasRole(r.roleCheck);
                        }
                        return true;
                    }).map(function(route) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_navigation_ActiveNavLink__WEBPACK_IMPORTED_MODULE_2__/* .ActiveLink */ .O, {
                            href: route.route,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "focus-within text-passport items-center flex justify-between pl-6 py-4 hover:bg-teal-100 rounded-md mt-1",
                                children: route.name
                            }, route.name)
                        }, route.name);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.div */ .E.div, {
                    initial: false,
                    animate: {
                        left: "".concat(240, "px")
                    },
                    className: "absolute top-0 right-0 bottom-0 ".concat(bgColor, " overflow-auto"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.div */ .E.div, {
                        className: "max-w-5xl mx-auto w-full h-full px-8",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                !!breadCrumbUrl && !!breadCrumb && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center text-gray-300 gap-x-1 mt-4",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                            href: "/users/edit",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skipper_ui__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                                as: "a",
                                                type: "link",
                                                css: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: "Account"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "/"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                            href: breadCrumbUrl,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skipper_ui__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                                as: "a",
                                                type: "link",
                                                children: breadCrumb
                                            })
                                        }),
                                        !!breadCrumSub && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "/"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                    href: breadCrumSubUrl,
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skipper_ui__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                                        as: "a",
                                                        type: "link",
                                                        children: breadCrumSub
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                children
                            ]
                        })
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 91007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BillingPlans; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/layout/leftNav/LeftsideNav.tsx
var LeftsideNav = __webpack_require__(3023);
// EXTERNAL MODULE: ./hooks/user/useUserPermissions.ts
var useUserPermissions = __webpack_require__(38734);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/context/UniversalModalContext.tsx
var UniversalModalContext = __webpack_require__(47614);
// EXTERNAL MODULE: ./components/common/panels/WhitePanel.tsx
var WhitePanel = __webpack_require__(59618);
// EXTERNAL MODULE: ./graphql/generated-graphql.ts
var generated_graphql = __webpack_require__(78616);
// EXTERNAL MODULE: ./graphql/graphql-client/graphClient.ts
var graphClient = __webpack_require__(52789);
// EXTERNAL MODULE: ./components/base/index.ts + 4 modules
var base = __webpack_require__(34867);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(28879);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./components/base/overlays/Modal/SimpleModal.tsx
var SimpleModal = __webpack_require__(18235);
;// CONCATENATED MODULE: ./public/svgs/skipper-octopus.svg
/* harmony default export */ var skipper_octopus = ({"src":"/_next/static/media/skipper-octopus.39567ba0.svg","height":87,"width":88});
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./pages/account/billing.tsx




















function BillingPlans() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var router = (0,next_router.useRouter)();
    var dispatchNotification = (0,UniversalModalContext/* useUniversalModalDispatch */.Xt)().dispatchNotification;
    var ref15 = (0,UniversalModalContext/* useUniversalModalDispatch */.Xt)(), toggleModal = ref15.toggle;
    var ref16 = (0,generated_graphql/* useAccountDetailsQuery */.Y$I)((0,graphClient/* getClient */.s3)("users")), data = ref16.data, refetch = ref16.refetch;
    var ref17 = (0,generated_graphql/* useSubscriptionPlansQuery */.CSW)((0,graphClient/* getClient */.s3)("users")), plansData = ref17.data;
    var ref18 = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), annualSwitch = ref18[0], setAnnualSwitch = ref18[1];
    var ref19 = (0,generated_graphql/* useStripeUpcomingInvoiceQuery */.qGW)((0,graphClient/* getClient */.s3)("users")), stripeUpcomingInvoiceData = ref19.data, refetchInvoice = ref19.refetch;
    var startSubscription = (0,generated_graphql/* useCreateSubscriptionMutation */.hoF)((0,graphClient/* getClient */.s3)("users"), {
        onSuccess: function(data, args) {
            var ref;
            if (data === null || data === void 0 ? void 0 : (ref = data.createSubscription) === null || ref === void 0 ? void 0 : ref.success) {
                refetch();
                refetchInvoice();
                if (data.createSubscription.redirectUrl) router.push(data.createSubscription.redirectUrl, undefined, {
                    shallow: false
                });
                else if (data.createSubscription.invoicePreview) {
                    toggleModal(true, /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleModal/* SimpleModal */.Y, {
                        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: skipper_octopus,
                                        width: 84,
                                        height: 84,
                                        layout: "fixed",
                                        className: "pointer-events-none"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-xl font-medium my-4",
                                    children: "Update your subscription"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "px-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "",
                                            children: [
                                                "You are about to switch to the ",
                                                data.createSubscription.subscriptionPlan.title,
                                                " plan!"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-2 font-medium",
                                            children: [
                                                "Due today: ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "font-medium",
                                                    children: [
                                                        "$",
                                                        data.createSubscription.invoicePreview.amount_due / 100
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-xs max-w-sm mx-auto mt-4 text-gray-700",
                                            children: 'By clicking "Confirm Update", you agree to the new rate and our Terms of Service. This change will take effect immediately.'
                                        })
                                    ]
                                })
                            ]
                        }),
                        confirmLabel: "Confirm Update",
                        onConfirm: function() {
                            startSubscription.mutate((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, args), {
                                forceUpdate: true
                            }));
                        }
                    }));
                } else if (args.forceUpdate) {
                    dispatchNotification({
                        title: "Subscription updated successfully",
                        text: "",
                        type: "success"
                    });
                    [
                        1,
                        3,
                        5,
                        10
                    ].map(function(i) {
                        return setTimeout(refetch, i * 1000);
                    });
                    [
                        1,
                        3,
                        5,
                        10
                    ].map(function(i) {
                        return setTimeout(refetchInvoice, i * 1000);
                    });
                }
            }
        }
    });
    var handleStartSubscription = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(plan, priceId) {
            var ref, ref1, ref2, ref3, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!plan) return [
                    2
                ];
                _tmp = {};
                if (plan.maxCourses && plan.maxCourses < (data === null || data === void 0 ? void 0 : (ref = data.account) === null || ref === void 0 ? void 0 : ref.subscriptionTotalCourses) || plan.maxActivities && plan.maxActivities < (data === null || data === void 0 ? void 0 : (ref1 = data.account) === null || ref1 === void 0 ? void 0 : ref1.subscriptionTotalActivities) || plan.maxStudents && plan.maxStudents < (data === null || data === void 0 ? void 0 : (ref2 = data.account) === null || ref2 === void 0 ? void 0 : ref2.subscriptionTotalStudents) || plan.maxInstructors && plan.maxInstructors < (data === null || data === void 0 ? void 0 : (ref3 = data.account) === null || ref3 === void 0 ? void 0 : ref3.subscriptionTotalInstructors)) {
                    dispatchNotification((_tmp.title = "Please adjust your account usage to fit within the new plan limits", _tmp.text = "", _tmp.type = "danger", _tmp));
                    return [
                        2
                    ];
                }
                _tmp1 = {};
                // if (plan.priceMonthly < (data?.account?.subscriptionPlan?.priceMonthly)) {
                //     toggleModal(
                //         true,
                //         <SimpleModal
                //             type="warning"
                //             title={`Downgrade to ${plan.title}`}
                //             body={<>
                //                 Are you sure you want to downgrade now?
                //                 <div className={"mt-4 px-16 text-sm text-orange-500"}>
                //                     NOTE - there are no refunds, any unused time will be prorated and credited to the new or future plans
                //                 </div>
                //             </>}
                //             confirmLabel={'Downgrade'}
                //             onConfirm={() => {
                //                 startSubscription.mutate({
                //                     priceId,
                //                     subscriptionPlanId: plan.id,
                //                 })
                //             }}
                //         />,
                //     );
                // } else
                startSubscription.mutate((_tmp1.priceId = priceId, _tmp1.subscriptionPlanId = plan.id, _tmp1));
                return [
                    2
                ];
            });
        });
        return function handleStartSubscription(plan, priceId) {
            return _ref.apply(this, arguments);
        };
    }();
    var createStripeDeepLink = (0,generated_graphql/* useCreateStripeDeepLinkMutation */.XV_)((0,graphClient/* getClient */.s3)("users"), {
        onSuccess: function(data) {
            var ref;
            if (data === null || data === void 0 ? void 0 : (ref = data.createStripeDeepLink) === null || ref === void 0 ? void 0 : ref.url) {
                router.push(data.createStripeDeepLink.url);
            }
        }
    });
    (0,react.useEffect)(function() {
        var _query = router.query, success = _query.success, error = _query.error, emailConfirmed = _query.emailConfirmed;
        if (success) {
            dispatchNotification({
                title: success,
                text: "",
                type: "success"
            });
            router.replace(router.pathname, undefined, {
                shallow: true
            });
        } else if (error) {
            dispatchNotification({
                title: error,
                text: "",
                type: "danger"
            });
            router.replace(router.pathname, undefined, {
                shallow: true
            });
        }
    }, [
        router.query
    ]);
    var isDefaultFreePlan = (data === null || data === void 0 ? void 0 : (ref = data.account) === null || ref === void 0 ? void 0 : (ref1 = ref.subscriptionPlan) === null || ref1 === void 0 ? void 0 : ref1.productId) == "custom" && (data === null || data === void 0 ? void 0 : (ref2 = data.account) === null || ref2 === void 0 ? void 0 : ref2.subscriptionCustomPrice) == 0;
    var basicPlan = (0,react.useMemo)(function() {
        var ref;
        return plansData === null || plansData === void 0 ? void 0 : (ref = plansData.subscriptionPlans) === null || ref === void 0 ? void 0 : ref.find(function(p) {
            return p.productId == "basic";
        });
    }, [
        plansData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftsideNav/* LeftsideNav */.N, {
        bgColor: "bg-gray-50",
        breadCrumb: "Billing and Plans",
        breadCrumbUrl: "/account/billing",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Billing and Plans | Skipper"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col w-full pt-4 pb-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhitePanel/* WhitePanel */.x, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-xl mb-1",
                                children: "Billing and Plans"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "my-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full min-w-full font-medium text-base my-1",
                                    children: [
                                        "Your Current Plan:",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "mx-1 font-medium",
                                            children: (data === null || data === void 0 ? void 0 : (ref3 = data.account) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscriptionPlan) === null || ref4 === void 0 ? void 0 : ref4.title) || "none"
                                        })
                                    ]
                                }),
                                (data === null || data === void 0 ? void 0 : (ref5 = data.account) === null || ref5 === void 0 ? void 0 : ref5.subscriptionEndDate) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full min-w-full text-sm",
                                    children: [
                                        "Next payment due on",
                                        (stripeUpcomingInvoiceData === null || stripeUpcomingInvoiceData === void 0 ? void 0 : stripeUpcomingInvoiceData.stripeUpcomingInvoice) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "mx-1",
                                                    children: dayjs_min_default()(stripeUpcomingInvoiceData.stripeUpcomingInvoice.created * 1000).format("MMMM DD, YYYY")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "font-bold",
                                                    children: [
                                                        "$",
                                                        ((stripeUpcomingInvoiceData.stripeUpcomingInvoice.amount_due || 0) / 100).toFixed(2)
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full min-w-full text-sm",
                                    children: [
                                        "No payment due:",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "mx-1 font-bold",
                                            children: "$0.00"
                                        })
                                    ]
                                }),
                                (data === null || data === void 0 ? void 0 : (ref6 = data.account) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.subscriptionPlan) === null || ref7 === void 0 ? void 0 : ref7.productId) != "custom" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex gap-4 mt-2",
                                        children: [
                                            ((data === null || data === void 0 ? void 0 : (ref8 = data.account) === null || ref8 === void 0 ? void 0 : ref8.subscriptionCustomPrice) || 0) != 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#",
                                                className: "text-sm text-teal-600 hover:underline hover:text-teal-500",
                                                onClick: function() {
                                                    return createStripeDeepLink.mutate({
                                                        type: "manage-payment"
                                                    });
                                                },
                                                children: "Manage Payment Method"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#",
                                                className: "text-sm text-teal-600 hover:underline hover:text-teal-500",
                                                onClick: function() {
                                                    return createStripeDeepLink.mutate({
                                                        type: "payment-history"
                                                    });
                                                },
                                                children: "View Payment History"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "my-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full min-w-full font-medium text-base my-1",
                                    children: "Current Usage"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "text-sm list-disc ml-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                data === null || data === void 0 ? void 0 : (ref9 = data.account) === null || ref9 === void 0 ? void 0 : ref9.subscriptionTotalCourses,
                                                " active courses"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                data === null || data === void 0 ? void 0 : (ref10 = data.account) === null || ref10 === void 0 ? void 0 : ref10.subscriptionTotalActivities,
                                                " activities"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                data === null || data === void 0 ? void 0 : (ref11 = data.account) === null || ref11 === void 0 ? void 0 : ref11.subscriptionTotalStudents,
                                                " students"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                data === null || data === void 0 ? void 0 : (ref12 = data.account) === null || ref12 === void 0 ? void 0 : ref12.subscriptionTotalInstructors,
                                                " course leaders"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-2 text-sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "Monthly Plans"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(base/* Toggle */.ZD, {
                                    enabled: annualSwitch,
                                    type: "button",
                                    bidirectional: true,
                                    setEnabled: function() {
                                        return setAnnualSwitch(!annualSwitch);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "Annual Plans"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full my-4 flex justify-center gap-4 flex-wrap",
                            children: plansData === null || plansData === void 0 ? void 0 : (ref13 = plansData.subscriptionPlans) === null || ref13 === void 0 ? void 0 : ref13.filter(function(p) {
                                return p.productId != "custom" && p.productId != "business";
                            }).map(function(plan) {
                                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                                var isCurrentLevel = (data === null || data === void 0 ? void 0 : (ref = data.account) === null || ref === void 0 ? void 0 : (ref1 = ref.subscriptionPlan) === null || ref1 === void 0 ? void 0 : ref1.productId) === plan.productId;
                                var currentIsMonthly = (data === null || data === void 0 ? void 0 : (ref2 = data.account) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscriptionCustomInterval) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) === "month";
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-sm min-w-40 text-center border border-gray-150 shadow shadow-xs rounded-lg p-3 ".concat((data === null || data === void 0 ? void 0 : (ref4 = data.account) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.subscriptionPlan) === null || ref5 === void 0 ? void 0 : ref5.productId) === plan.productId ? "bg-teal-050" : ""),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-base font-medium",
                                            children: plan.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "my-3 flex flex-col gap-2 h-12",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "text-xl font-medium",
                                                    children: [
                                                        "$",
                                                        !annualSwitch ? plan.priceMonthly : plan.priceAnnual / 12,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-base",
                                                            children: "/mo"
                                                        })
                                                    ]
                                                }),
                                                plan.priceMonthly > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-xs",
                                                    children: !annualSwitch ? "Billed monthly" : "Billed annually"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(base/* Button */.zx, {
                                            variant: isCurrentLevel ? "subtle" : plan.priceMonthly >= (data === null || data === void 0 ? void 0 : (ref6 = data.account) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.subscriptionPlan) === null || ref7 === void 0 ? void 0 : ref7.priceMonthly) ? "primary" : "white",
                                            size: "small",
                                            className: "w-32 px-0 my-4 justify-center",
                                            // disabled={startSubscription.isLoading}
                                            onClick: function() {
                                                return (!isCurrentLevel || annualSwitch && currentIsMonthly || !annualSwitch && !currentIsMonthly) && handleStartSubscription(plan, annualSwitch ? plan.annualPriceId : plan.monthlyPriceId);
                                            },
                                            children: isCurrentLevel ? annualSwitch && currentIsMonthly ? "Go Yearly" : !annualSwitch && !currentIsMonthly ? "Go Monthly" : "Current Plan" : isDefaultFreePlan ? "Select" : plan.priceMonthly >= (data === null || data === void 0 ? void 0 : (ref8 = data.account) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.subscriptionPlan) === null || ref9 === void 0 ? void 0 : ref9.priceMonthly) ? "Upgrade" : "Downgrade"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: "text-xs list-disc mx-4 text-left leading-5 text-gray-700",
                                            children: plan.features.map(function(feature, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: feature
                                                }, index);
                                            })
                                        })
                                    ]
                                }, plan.id);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full border border-gray-150 shadow shadow-xs rounded-lg flex p-4 my-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-48 flex flex-col gap-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-base font-medium",
                                            children: "Business"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "my-3 flex flex-col gap-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-xl font-medium",
                                                children: "Custom pricing"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base/* Button */.zx, {
                                                variant: "primary",
                                                className: "px-2",
                                                size: "small",
                                                onClick: function() {
                                                    return router.push("mailto:sales@skipper.io");
                                                },
                                                type: "submit",
                                                children: "Talk to Sales"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex-1 flex flex-col gap-4 justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-sm",
                                            children: "Are you an organization, non-profit, co-op, or school? Contact us for special pricing."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-sm",
                                            children: "Including white-glove onboarding, private training, priority customer support, and special pricing for academic add-on’s (e.g., Turnitin, Career Discovery Platform)"
                                        })
                                    ]
                                })
                            ]
                        }),
                        (data === null || data === void 0 ? void 0 : (ref14 = data.account) === null || ref14 === void 0 ? void 0 : ref14.subscriptionPlan) && data.account.subscriptionPlan.productId !== "basic" && data.account.subscriptionPlan.productId !== "custom" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                    className: "my-8"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-lg font-medium",
                                    children: "Cancel Subscription"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-xs leading-5 mt-1",
                                    children: "Upon cancelling your subscription, you will be downgraded to our Free plan. You can always join another account's course as a course leader, parent observer, or student, free of charge."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "my-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-xs leading-5",
                                            children: "Please adjust your account if it currently exceeds these limits before proceeding with cancellation:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "list-disc mx-4 text-xs text-left leading-5",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "1 active course"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "100 activities"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "10 students"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "2 instructors/course leaders"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(base/* Button */.zx, {
                                    variant: "red",
                                    size: "small",
                                    className: "",
                                    onClick: function() {
                                        return handleStartSubscription(basicPlan, basicPlan === null || basicPlan === void 0 ? void 0 : basicPlan.annualPriceId);
                                    },
                                    children: "Cancel Subscription"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
BillingPlans.displayName = "Billing and Plans";
BillingPlans.useDefault = true;
BillingPlans.requiredRole = useUserPermissions/* Roles.Adult */.G7.Adult;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(73252); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);